const { SET_SIDEBAR } = require('../Constants/sidebar.constants');

export const sideBarState = (data) => ({
    type: SET_SIDEBAR,
    data
});
